import styled, { createGlobalStyle  } from 'styled-components';
import Amsterdam from './assets/fonts/Amsterdam_400.ttf';
import AmsterdamFour from './assets/fonts/Amsterdam_Four_ttf_400.ttf';

const GlobalStyle = createGlobalStyle`
    @font-face {
        font-family: 'Amsterdam Four'; // Nombre que le das a la fuente
        src: url(${AmsterdamFour}) format('truetype');
        font-weight: normal; // O el peso que corresponda
        font-style: normal;
    }
`;

export default GlobalStyle;